'use client';

import { buttonClass } from '@baseline/ui';
import styles from '../baselineSummit.module.scss';

const LUMA_EVENT_URL = 'https://luma.com/event/evt-0Bq8YHDbdkYAEh2';
const LUMA_EVENT_ID = 'evt-0Bq8YHDbdkYAEh2';

const LumaRegisterButton = () => (
  <a
    href={LUMA_EVENT_URL}
    className={`${buttonClass({ size: 'medium' })} luma-checkout--button ${styles.registerButton}`}
    data-luma-action="checkout"
    data-luma-event-id={LUMA_EVENT_ID}
  >
    Register
  </a>
);

export default LumaRegisterButton;
